export const launchingSelfExclusion = {
  initial: 'idle',
  states: {
    idle: {
      on: {
        VIEW_SELF_EXCLUSION_BUTTON_CLICK: {
          target: 'openSelfExclusion',
        },
      },
    },
    openSelfExclusion: {
      entry: 'openSelfExclusion',
      always: 'idle',
    },
  },
};
